// make it work with --isolatedModules
export default {};
